import React, { useState, useRef, useContext } from 'react';
import {
  Avatar,
  Button,
  ClickAwayListener,
  Grow,
  Paper,
  Popper,
  MenuItem,
  MenuList,
  Typography,
  Box,
  IconButton,
} from '@mui/material';
import {
  Settings as SettingsIcon,
  ExitToApp as LogoutIcon,
  SupervisedUserCircle as SupervisedUserCircleIcon,
} from '@mui/icons-material';
import { useHistory, useLocation } from 'react-router-dom';
import { UserContext } from '../../Contexts/UserContext';
import useBreakpoints from 'src/utils/Breakpoints';
import { Menu, Bell, Home, MapPin, ChevronRight } from 'lucide-react';
import { globalLogoutFunction } from 'src/utils/handleCookie';
const AppHeaderDropdown = ({ avatarSrc, currentMessage }) => {
  const { contextUserData, showBanner, setShowBanner } = useContext(UserContext);
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const history = useHistory();
  const { isSm, isMd, isLg } = useBreakpoints();
  const hasMessages = currentMessage && currentMessage.length > 0;
  const location = useLocation();
  const logout = async () => {

    await globalLogoutFunction()
    history.push('/login');

  };

  const changePassword = () => {
    history.push('/changepassword');
  };

  const updateuserdetails = () => {
    history.push('/updateuserdetails');
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const handleListKeyDown = (event) => {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  };

  return (
    <Box sx={{ display: 'inline-block' }}>
      <Button
        ref={anchorRef}
        onClick={handleToggle}
        sx={{
          textTransform: 'none',
          padding: isSm ? '4px 6px' : '8px 12px',
          borderRadius: '8px',
          minWidth: isSm ? 0 : undefined,
          transition: 'all 0.2s ease',
          backdropFilter: 'blur(8px)',
          backgroundColor: open ? 'rgba(0,0,0,0.2)' : 'rgba(25, 118, 210, 0.1)',
          border: '1px solid rgba(255,255,255,0.1)',
          '&:hover': {
            backgroundColor: '#5B4CE2',
            color: 'white',
            boxShadow: '0px 4px 12px rgba(91, 76, 226, 0.25)',
            transform: 'translateY(-2px)',
            '& .user-id': {
              color: 'white'
            },
            '& .user-role': {
              color: 'white'
            }
          }
        }}
      >
        <Avatar
          src={avatarSrc}
          sx={{
            width: isLg ? 40 : isMd ? 32 : 28,
            height: isLg ? 40 : isMd ? 32 : 28,
            marginRight: isSm ? 0 : 1.5,
            backgroundColor: '#ffffff',
            color: '#6366f1',
            fontSize: isLg ? '1.2rem' : isMd ? "0.9rem" : "0.7rem",
            fontWeight: 600,
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
          }}
        />
        {!isSm && <Box sx={{ textAlign: 'left' }}>
          <Typography
            className="user-id"
            variant="h6"
            sx={{
              fontWeight: 600,
              color: "rgb(107, 114, 128)",
              fontSize: '0.95rem',
              lineHeight: 1.2,
              textShadow: '0 1px 2px rgba(0,0,0,0.1)',
              transition: 'color 0.3s ease'
            }}
          >
            {contextUserData?.LoginUserID || "Username"}
          </Typography>
          <Typography
            className="user-role"
            variant="body1"
            sx={{
              color: "rgba(0, 0, 0, 0.6)",
              fontSize: '0.85rem',
              transition: 'color 0.3s ease'
            }}
          >
            {contextUserData?.UserName || "Designation"}
          </Typography>
        </Box>}
      </Button>

      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        placement={isSm ? 'bottom' : 'bottom-end'}
        sx={{ zIndex: 1300, width: isSm ? '100vw' : undefined, left: isSm ? 0 : undefined }}
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: placement === 'bottom-end' ? 'top right' : 'bottom right',
            }}
          >
            <Paper
              elevation={3}
              sx={{
                borderRadius: '8px',
                mt: 1,
                overflow: 'hidden',
                border: '1px solid rgba(99,102,241,0.1)',
                background: 'linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.98) 100%)',
                backdropFilter: 'blur(10px)',
                boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
                width: isSm ? '100vw' : undefined,
                left: isSm ? 0 : undefined
              }}
            >
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList
                  autoFocusItem={open}
                  onKeyDown={handleListKeyDown}
                  sx={{ py: 0 }}
                >
                  {isSm && (
                    <Box sx={{ px: 2, pt: 2, pb: 1, display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: "space-between", gap: 0.5 }}>
                      <Box>
                        <Typography
                          className="user-id"
                          variant="h6"
                          sx={{
                            fontWeight: 600,
                            color: "rgb(107, 114, 128)",
                            fontSize: '16px',
                            lineHeight: 1.2,
                            textShadow: '0 1px 2px rgba(0,0,0,0.1)',
                            transition: 'color 0.3s ease',
                            mb: 0.5
                          }}
                        >
                          {contextUserData?.LoginUserID || "Username"}
                        </Typography>
                        <Typography
                          className="user-role"
                          variant="body1"
                          sx={{
                            color: "rgba(0, 0, 0, 0.6)",
                            fontSize: '14px',
                            transition: 'color 0.3s ease',
                            mb: 1
                          }}
                        >
                          {contextUserData?.UserName || "Designation"}
                        </Typography>
                      </Box>

                      <Box sx={{ display: 'flex', gap: 1, mb: 1 }}>
                        {location.pathname?.trim() !== "/home" && <IconButton
                          size="small"
                          onClick={() => history.push('/home')}
                          sx={{ color: '#4f46e5', backgroundColor: 'rgba(79, 70, 229, 0.1)', '&:hover': { backgroundColor: 'rgba(79, 70, 229, 0.2)' } }}
                        >
                          <Home size={24} />
                        </IconButton>}
                        <Box sx={{ position: 'relative' }}>
                          <IconButton
                            size="small"
                            onClick={() => {
                              const tempShowBanner = !showBanner;
                              setShowBanner(tempShowBanner);
                              localStorage.setItem('showBanner', tempShowBanner);
                              window.dispatchEvent(new CustomEvent('toggleBanner'));
                            }}
                            sx={{ color: '#4f46e5', backgroundColor: 'rgba(79, 70, 229, 0.1)', '&:hover': { backgroundColor: 'rgba(79, 70, 229, 0.2)' } }}
                          >
                            <Bell size={24} />
                          </IconButton>
                          {hasMessages && !showBanner && (
                            <Box sx={{
                              position: 'absolute',
                              top: 5,
                              right: 8,
                              width: 8,
                              height: 8,
                              borderRadius: '50%',
                              backgroundColor: '#c62828',
                              animation: 'pulse 1.5s infinite',
                              '@keyframes pulse': {
                                '0%': {
                                  transform: 'scale(0.95)',
                                  boxShadow: '0 0 0 0 rgba(198, 40, 40, 0.7)'
                                },
                                '70%': {
                                  transform: 'scale(1)',
                                  boxShadow: '0 0 0 8px rgba(198, 40, 40, 0)'
                                },
                                '100%': {
                                  transform: 'scale(0.95)',
                                  boxShadow: '0 0 0 0 rgba(198, 40, 40, 0)'
                                }
                              }
                            }} />
                          )}
                        </Box>
                      </Box>
                    </Box>
                  )}
                  <MenuItem
                    onClick={updateuserdetails}
                    sx={{
                      py: isSm ? 2 : 1,
                      px: isSm ? 2 : 2,
                      fontSize: isSm ? '1.1rem' : undefined,
                      transition: 'all 0.2s ease',
                      '&:hover': {
                        backgroundColor: 'rgba(99,102,241,0.4)',
                        transform: 'translateX(4px)'
                      },
                    }}
                  >
                    <SupervisedUserCircleIcon
                      fontSize="medium"
                      sx={{ mr: 2, color: '#6366f1' }}
                    />
                    <Typography variant="body1">Update Profile</Typography>
                  </MenuItem>

                  <MenuItem
                    onClick={changePassword}
                    sx={{
                      py: isSm ? 2 : 1,
                      px: isSm ? 2 : 2,
                      fontSize: isSm ? '1.1rem' : undefined,
                      transition: 'all 0.2s ease',
                      '&:hover': {
                        backgroundColor: 'rgba(99,102,241,0.4)',
                        transform: 'translateX(4px)'
                      },
                    }}
                  >
                    <SettingsIcon
                      fontSize="medium"
                      sx={{ mr: 2, color: '#6366f1' }}
                    />
                    <Typography variant="body1">Change Password</Typography>
                  </MenuItem>

                  <MenuItem
                    onClick={logout}
                    sx={{
                      py: isSm ? 2 : 1,
                      px: isSm ? 2 : 2,
                      fontSize: isSm ? '1.1rem' : undefined,
                      transition: 'all 0.2s ease',
                      '&:hover': {
                        backgroundColor: 'rgba(239,68,68,0.4)',
                        transform: 'translateX(4px)',
                        color: 'white'
                      },
                    }}
                  >
                    <LogoutIcon
                      fontSize="medium"
                      sx={{ mr: 2, color: '#ef4444' }}
                    />
                    <Typography
                      variant="body1"
                      sx={{ color: '#ef4444' }}
                    >
                      Logout
                    </Typography>
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </Box>
  );
};

export default AppHeaderDropdown;